import React from "react";
import ReactDOM from "react-dom";

const SelectAddressModal = ({
  addresses,
  selectedAddressId,
  onSelect,
  onClose,
  title,
}) => {
  return ReactDOM.createPortal(
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="modal-content p-24 rounded-8"
        style={{ background: "#fff", maxWidth: "500px", width: "90%" }}
      >
        <button
          onClick={onClose}
          className="close-btn absolute  text-sm text-gray-700 ms-auto"
        >
          ×
        </button>
        <h6 className="mb-10 text-sm fw-semibold">{title}</h6>

        <div
          className="address-list"
          style={{
            maxHeight: "300px", // limit height
            overflowY: "auto", // enable vertical scroll
            paddingRight: "8px", // prevent content hiding under scrollbar
          }}
        >
          {addresses && addresses.length > 0 ? (
            addresses.map((address) => (
              <div
                key={address.id}
                className="border p-12 rounded mb-8 text-sm"
              >
                <label className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="addressSelect"
                    value={address.id}
                    checked={selectedAddressId === address.id}
                    onChange={() => onSelect(address.id)}
                    className="me-8"
                  />
                  <span>
                    {address.firstName} {address.lastName}, {address.address1},{" "}
                    {address.city}
                  </span>
                </label>
              </div>
            ))
          ) : (
            <p>No addresses available.</p>
          )}
          <button className="btn btn-main mt-5 btn-sm" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default SelectAddressModal;
